import * as React from "react"

// Sidebar drawer / mobile-layout boundary. Lowered from 768 (md) to 640 (sm)
// so split-screen on 1366/1440-px monitors (683/720 viewport) keeps the
// desktop sidebar visible instead of collapsing it into a closed Sheet
// drawer. True phones (< 640) still get the drawer treatment. Pair with
// `hidden sm:block` on the Sidebar primitive (sidebar.tsx) and the
// `sm:`-gated logo / search / toggle classes in TopNavigation; the three
// places must agree on the same breakpoint or duplicate controls render.
const MOBILE_BREAKPOINT = 640

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}
